import axios from 'axios'
import { i18n } from '@/i18n'
export default {
  state: {
    statistic: [],
  },
  getters: {
    CoinsStat: (s) => s.statistic,
  },
  mutations: {
    updateStat(s, res) {
      s.statistic = res
    },
  },
  actions: {
    async fetchCoinsExchange(
      ctx,
      { coins_requested, first_name, last_name, third_party_user_id, country }
    ) {
      let obj = {
        coins_requested: coins_requested,
        first_name: first_name,
        last_name: last_name,
        third_party_user_id: third_party_user_id,
        country: country,
      }
      return axios({
        method: 'POST',
        url: 'api/gamification/coins-exchange/',
        data: obj,
      })
        .then(() => {
          return true
        })
        .catch((error) => {
          console.error(error)
          if (
            error.response.data.includes(
              'You already have a pending application'
            )
          ) {
            ctx.dispatch('fetchAlerts', {
              alerts: 'У вас уже создана заявка на перевод коинов',
              type: 'error',
            })
          } else if (
            error.response.data.includes(
              'Not enough coins to create application'
            )
          ) {
            ctx.dispatch('fetchAlerts', {
              alerts: 'Недостаточно коинов',
              type: 'error',
            })
          } else {
            ctx.dispatch('fetchAlerts', {
              alerts: i18n.t(`interface.errors.000`),
              type: 'error',
            })
          }

          return false
        })
    },
    async fetchCoinsStat(ctx) {
      return axios({
        method: 'GET',
        url: 'api/gamification/coins-exchange/',
      })
        .then((response) => {
          const list = response.data.results
          ctx.commit('updateStat', list)
          return true
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
  },
}
